import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'projects/sharing/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(e: KeyboardEvent): boolean {
    if (environment.disabledDevTools) {
      const event = e;
      if (
        event.keyCode === 123 ||
        (event.ctrlKey && event.shiftKey && event.keyCode === 73) ||
        (event.ctrlKey && event.shiftKey && event.keyCode === 75)
      ) {
        return false;
      }
      if (event.ctrlKey && event.keyCode === 85) {
        return false;
      }
    }
    return true;
  }
  constructor(private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
    if (environment.disabledDevTools) {
      document.addEventListener('contextmenu', function (e) {
        e.preventDefault();
      });
    }
  }

  ngOnInit(): void {
    const splash = document.getElementById('splash-screen');
    if (splash) {
      splash.style.display = 'none';
    }
  }
}
